/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportParameterDto
 */
export interface ReportParameterDto {
    /**
     * 
     * @type {string}
     * @memberof ReportParameterDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportParameterDto
     */
    prompt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportParameterDto
     */
    dataType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportParameterDto
     */
    value?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportParameterDto
     */
    required?: boolean | null;
}

/**
 * Check if a given object implements the ReportParameterDto interface.
 */
export function instanceOfReportParameterDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReportParameterDtoFromJSON(json: any): ReportParameterDto {
    return ReportParameterDtoFromJSONTyped(json, false);
}

export function ReportParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportParameterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'prompt': !exists(json, 'prompt') ? undefined : json['prompt'],
        'dataType': !exists(json, 'dataType') ? undefined : json['dataType'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'required': !exists(json, 'required') ? undefined : json['required'],
    };
}

export function ReportParameterDtoToJSON(value?: ReportParameterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'prompt': value.prompt,
        'dataType': value.dataType,
        'value': value.value,
        'required': value.required,
    };
}

